module.exports = __webpack_public_path__ + "static/media/theparker.b8b811fe.png";